<template>
        <div class="detail-row">
            <div class="form-group">
                <label>Date comptable: </label>
                <span>{{date_comptable_format }} </span>
            </div>
            <div class="form-group">
                <label>Date valeur: </label>
                <span>{{date_valeur_format }} </span>
            </div>
            <div class="form-group">
                <label>Libellés: </label>
                <span> {{libelle}}</span>
            </div>
            <div class="form-group">
                <label>Détails: </label>
                <span><pre>{{details_format}} </pre></span>
            </div>
            <div class="form-group">
                <label>Communication: </label>
                <span>{{ communication }}</span>
            </div>
        </div>
</template>


<script type="text/babel">
    var moment = require('moment');
    export default {
        computed: {
            date_comptable_format: function () {
                return moment(this.date_comptable, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY')
            },
            date_valeur_format: function () {
                return moment(this.date_valeur, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY')
            },
            details_format: function () {
                return this.details.replace(/\\n|\\r\\n|\\r/g, "\n")
            }
        },
        methods: {},
        data() {
            return {
                date_comptable: this.rowData.date_comptable,
                date_valeur: this.rowData.date_valeur,
                libelle: this.rowData.libelle,
                details: this.rowData.details,
                communication: this.rowData.communication
            }
        },
        props: {
            /*item: {
                type: Object,
                required: true
            },
            size: {
                type: Number,
                required: true
            },*/
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            }
        }
        ,
        ready() {
//            this.date_comptable = this.item.date_comptable
//            this.date_valeur = this.item.date_valeur
//            this.libelle = this.item.libelle
//            this.details = this.item.details
//            this.communication = this.item.communication
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/VueTable/Templates/RowDetailsOperations.vue